$(document).ready(function () {

    ub.dataPatches = {};
    ub.data.transferColors = ['5882',];

    // Fix save designs 4874 to 5728, pre color array fix (commit: c643b1f)
    ub.dataPatches.patch4874to5728 = function () {

        var _idsV = ["4874", "4875", "4876"]; // Volg 
        var _idsG = ["5728"]; // Goldston
        var _id5225 = ["5225"];
        var _id5679 = ["5679"];
        var _id5880 = ["5880"];
        var _id5882 = ["5882"];

        var _id5924 = ["5924"];
        var _id11214 = ["11214"];

        // Volg
        if (typeof ub.config.savedDesignInfo === "object" && _.contains(_idsV, ub.config.savedDesignInfo.savedDesignID)) {
            ub.current_material.settings.applications[72].color_array = ub.colorUtilities.colorCodesToColorObjArray(["B", "W"]);
            ub.current_material.settings.applications[73].color_array = ub.colorUtilities.colorCodesToColorObjArray(["B"]);
        }

        // Goldston
        if (typeof ub.config.savedDesignInfo === "object" && _.contains(_idsG, ub.config.savedDesignInfo.savedDesignID)) {
            ub.current_material.settings.applications[5].color_array = ub.colorUtilities.colorCodesToColorObjArray(["T", "B", "VG"]);
        }

        // 5225
        if (typeof ub.config.savedDesignInfo === "object" &&  _.contains(_id5225, ub.config.savedDesignInfo.savedDesignID)) {
            ub.current_material.settings.applications[1].color_array = ub.colorUtilities.colorCodesToColorObjArray(["RB",'G']);
            ub.current_material.settings.applications[26].color_array = ub.colorUtilities.colorCodesToColorObjArray(["RB",'G']);
            ub.current_material.settings.applications[5].color_array = ub.colorUtilities.colorCodesToColorObjArray(["RB",'G']);
        }

        // Dekalb Sleeves
        if (typeof ub.config.savedDesignInfo === "object" && _.contains(_id5679, ub.config.savedDesignInfo.savedDesignID)) {
            ub.current_material.settings.applications[72].status = "off";
        }

        // 5880
        if (typeof ub.config.savedDesignInfo === "object" && _.contains(_id5880, ub.config.savedDesignInfo.savedDesignID)) {
            ub.current_material.settings.applications[74].color_array = ub.colorUtilities.colorCodesToColorObjArray(["W"]);
        }

        // 5882
        if (typeof ub.config.savedDesignInfo === "object" &&  _.contains(_id5882, ub.config.savedDesignInfo.savedDesignID)) {
            ub.current_material.settings.applications[72].color_array = ub.colorUtilities.colorCodesToColorObjArray(["LG",'W']);
            ub.current_material.settings.applications[74].color_array = ub.colorUtilities.colorCodesToColorObjArray(["LG",'W']);
            ub.current_material.settings.applications[75].color_array = ub.colorUtilities.colorCodesToColorObjArray(["LG",'W']);
        }

        // 5924
        if (typeof ub.config.savedDesignInfo === "object" &&  _.contains(_id5924, ub.config.savedDesignInfo.savedDesignID)) {
            
            ub.current_material.settings.applications[78].application.layer = "Left Sleeve";
            ub.current_material.settings.applications[79].application.layer = "Left Sleeve";
            ub.current_material.settings.applications[85].status = "off";

            ub.current_material.settings.applications[80].status = "off";
            ub.current_material.settings.applications[84].status = "off";
            ub.current_material.settings.applications[79].status = "off";
            ub.current_material.settings.applications[78].status = "off";
            
        }

        // 11214
        if (typeof ub.config.savedDesignInfo === "object" &&  _.contains(_id11214, ub.config.savedDesignInfo.savedDesignID)) {
            
            console.error('---- Start Patch ----');

            _.each(ub.current_material.settings.applications, function (application, key) {

                console.log(application)
                console.log(application.application.layer);
                console.log(key);

                if (application.application.layer === "Back Insert") {
                    console.log('Deleting ' + key);
                    delete ub.current_material.settings.applications[key];	
                }

                if (key ===  "83") {
                    console.log('Hiding 83');
                    application.status = "off";
                }

                if (key === "78") {
                    console.log('Hiding 78');
                    application.status = "off";
                }

                if (key ===  "82") {
                    console.log('Hiding 82');
                    application.status = "off";
                }

                if (key === "80") {
                    console.log('Hiding 80');
                    application.status = "off";
                }

                if (key === "81") {
                    console.log('Hiding 81');
                    application.status = "off";
                }
                
            });

            console.error('---- End Patch ----');
            
        }

    }

    ub.dataPatches.patchForPerspectiveIssues = function() {
        if (_.isEmpty(ub.config.savedDesignInfo) === false) {
            // Add the savedDesignId and the perspective/s that will be omitted. @var _savedDesigns
            var _savedDesigns = [
                { 
                    "savedDesignID" : "43030", 
                    "omitPerspectives"	: ['left', 'right'],
                }, { 
                    "savedDesignID" : "44473", 
                    "omitPerspectives"	: ['left', 'right'],
                },
            ];
            
            var data = _.findWhere(_savedDesigns, {"savedDesignID" : ub.config.savedDesignInfo.savedDesignID});

            if (_.isEmpty(data) === false) {
                _.each(ub.current_material.settings.applications, function (application) {
                    application.application.views = _.omit(application.application.views, function (app) {
                        return _.contains(data.omitPerspectives, app.perspective);
                    });
                });

                console.groupCollapsed('%c ----- A Patch is Detected for this Saved Design Item. -----', 'background: #222; color: #bada55');
                console.info("Design: %s is not covered with latest changes in the application, a patch for this design will be applied.", data.savedDesignID);
                console.info("Saved Design Successfully Patched!");
                console.groupEnd();
            }
        }
    }

    ub.dataPatches.forRandomFeedPatching = function () {

        var _id13233 = ["13233"];
        var _ok = typeof ub.config.savedDesignInfo === "object" &&  _.contains(_id13233, ub.config.savedDesignInfo.savedDesignID);

        if (_ok) { ub.current_material.settings.randomFeeds = {}; }

        return _ok;

    }

    ub.dataPatches.avoidHiddenBody = function() {
        var uniformIDs = [
            "5308", 
            // see ub.data.hasSeparatedSleeve
            // requested by Web GAs
            "7585", // XSD-BSBC-AS
            "7586", // XSD-BSBV-AS
            "7587", // XSD-BSB2-AS
            "7588",  // XSD-BSBFB-AS
            "7603",  // XSD-SFT2-AS
            "7604",  // XSD-SFTV-AS
            "7605",  // XSD-SFTFB-AS
            "7609",  // XSD-SFT2-07
            "7610",  // XSD-SFTV-07
            "7611",  // XSD-SFTFB-07
            // display BODY
            // requested by Kenneth (06/2021)
            "7620",
            "7621",
            "7622",
            "7623",
            "7624",
            "7631",
            "7625", 
            "7626", 
            "7627", 
            "7628", 
            "7629", 
            "7630",
            "7699",
            // requested by Khei (06/2021)
            // Basketball shorts
            "7740",
            "7741",
            "7742",
            "7743",
            "7744",
            "7745",
            // requested by Ken (10/2021)
            // Basketball shorts
            "8466",
            "8467",
            "8468",
            "8469",
            "8470",
            "8471",
        ];

        var materialId = ub.config.material_id.toString();
        var onUniformIDs = _.contains(uniformIDs, materialId);

        if (onUniformIDs) {
            ub.config.hiddenBody = false;
            console.log("%c A patch is detected for this uniform.... Set hidden_body_flag to false.... ", "background: #222; color: #bada55");
        } else {
            ub.config.hiddenBody = ub.current_material.material.hidden_body ? true : false;
            console.log("Using material Hidden Body");
        }

    }

    ub.dataPatches.patchForMaterialOptionPanel = function() {
        var _materialsOptions = ub.current_material.settings.upper;

        if (typeof ub.config.savedDesignInfo !== 'undefined') {
            if (ub.config.savedDesignInfo['savedDesignID'] == '71333') {
                console.log("%c A patch is detected for this uniform.... ", "background: #222; color: #bada55");
                _materialsOptions['Left Shoulders'] = _materialsOptions['Left Shoulder Panel'];
                _materialsOptions['Right Shoulders'] = _materialsOptions['Right Shoulder Panel'];
                _materialsOptions['Left Side Panel'] = _materialsOptions['Left Under Arm Vent'];
                _materialsOptions['Right Side Panel'] = _materialsOptions['Right Under Arm Vent'];

                delete _materialsOptions['Left Shoulder Panel'];
                delete _materialsOptions['Right Shoulder Panel'];
                delete _materialsOptions['Left Under Arm Vent'];
                delete _materialsOptions['Right Under Arm Vent'];

                _materialsOptions['Left Shoulders'].code = 'left_shoulders'
                _materialsOptions['Right Shoulders'].code = 'right_shoulders'
                _materialsOptions['Left Side Panel'].code = 'left_side_panel'
                _materialsOptions['Right Side Panel'].code = 'right_side_panel'
            }
        }
    }

    ub.dataPatches.patch72968 = function() {
        var obj74 = ub.current_material.settings.applications[74];
        var obj75 = ub.current_material.settings.applications[75];

        if (typeof ub.config.savedDesignInfo !== 'undefined') {
            if (ub.config.savedDesignInfo["savedDesignID"] == "72968") {
                if (typeof ub.objects.front_view.objects_75 !== "undefined") ub.objects.front_view.objects_75["zIndex"] = -225;
                if (typeof ub.objects.front_view.objects_74 !== "undefined") ub.objects.front_view.objects_74["zIndex"] = -225;

                obj74.zIndex = 1;
                obj75.zIndex = 2;
                console.log("%c A patch is detected for this savedDesignID 72968.... Add zIndex property to application 74 and 75.... ", "background: #222; color: #bada55");
            }
        }
    }

    ub.dataPatches.firstLoadPatch75158 = function() {
        var uniform_type = ub.current_material.material.type;
        var _type = ub.current_material.settings[uniform_type];

        if (typeof(ub.config.savedDesignInfo) !== 'undefined') {
            if (ub.config.savedDesignInfo['savedDesignID'] == "75158") {
                _type['Left Sleeve'].code         = 'left_sleeves';
                _type['Right Sleeve'].code        = 'right_sleeves';
                _type['Front Body Panel'].code    = 'front_panel';
                _type['Back Body Panel'].code     = 'back_panel';
                _type['Inside Neck Trim'].code    = 'inner_neck_trim';
                _type['Front Top Stripe'].code    = 'body_stripe_1';
                _type['Front Middle Stripe'].code = 'body_stripe_2';
                _type['Back Top Stripe'].code     = 'body_stripe_3';
                _type['Back Middle Stripe'].code  = 'body_stripe_4';
            }
        }
    }

    // ORDER PATCHES
    ub.dataPatches.patch77d6cf0188b0 = function() {
        var sport = ub.sport;
        var objIds = [71, 72];

        if (typeof ub.config.orderCode !== 'undefined') {
            if (ub.config.orderCode == "77d6cf0188b0") {
                
                if (_.contains(['Face Mask (Quickturn)'], sport)) {
                    _.each(objIds, function(application_id) {
                        var app_obj = ub.current_material.settings.applications[application_id];
                        _.each(app_obj.application.views, function (view) {
                            if (view.isPrimary != 1) {
                                if (typeof view.application.position !== 'undefined') {
                                    ub.objects[view.perspective+'_view']['objects_'+application_id].position.x = view.application.position.x;
                                }
                            }
                        });
                    });

                    console.log("%c A patch is detected for this orderCode 77d6cf0188b0.... Fix position property to application 71 and 72.... ", "background: #222; color: #bada55");
                }
            }
        }
    }

    ub.dataPatches.patchForMaskHidePanel1 = function(_perspective) {

        if (ub.current_material.material.uniform_category === "Face Mask (Quickturn)") {
            if (_perspective === "left") {

                var newArr = [];

                _.each(ub.funcs.getFreeFormLayers(), function(option) {
                    var material = _.filter(ub.current_material.material.options, { name: option.name });
                    newArr.push(material);
                });

                var _flattenArr = _.flatten(newArr, true);
                var _newDataArr = _(_flattenArr).filter(function(item) {
                    return item.name !== "Bottom Binding" &&
                           item.name !== "Top Binding" &&
                           item.name !== "Elastic"
                });

                var _panel1 = _.filter(_newDataArr, { name: "Panel 1" });
                var _perspective = _.map(_panel1, function(panel) { 
                    return panel.perspective;
                });

                if(!_.contains(_perspective, "left")) {
                    $('span.part[data-id="Panel 1"]').hide();
                } else {
                    $('span.part[data-id="Panel 1"]').show();
                }

            } else {
                $('span.part[data-id="Panel 1"]').show();
            }
        }
    }

    ub.dataPatches.deleteSaveDesignApplication = function(id, num) {
        if (typeof ub.config.savedDesignInfo !== "undefined") {
            if (ub.config.savedDesignInfo["savedDesignID"] == id) {
                delete ub.current_material.settings.applications[num];
            }
        }
    }

    ub.dataPatches.patchSavedDesign71059 = function() {
        if (typeof ub.config.savedDesignInfo !== "undefined" 
            && ub.config.savedDesignInfo.savedDesignID === "71059") {
                var _modifier_labels = ub.data.modifierLabels;
                var _piping = "left_under_arm_piping";
                var _side_insert = "left_under_arm_insert"

                _.each(_modifier_labels, function(parts){
                    if(parts.fullname === "left_piping"){
                        parts.fullname_old = _piping;
                    }

                    if(parts.fullname === "left_side_insert"){
                        parts.fullname_old = _side_insert;
                    };

                });
        }
    }

    ub.dataPatches.patchSavedDesign71059MaterialOptionObject = function(materialOptionCode, object) {
        var type = ub.current_material.material.type;
        var uniformObject = ub.current_material.settings[type];
        var materialOptionObject = object;

        if (typeof ub.config.savedDesignInfo !== "undefined" 
            && ub.config.savedDesignInfo.savedDesignID === "71059") {
                if (materialOptionCode === "left_side_insert") {
                    materialOptionObject = _.find(uniformObject, {code: 'left_under_arm_insert'});
                } else if (materialOptionCode === "right_side_insert") {
                    materialOptionObject = _.find(uniformObject, {code: 'right_under_arm_insert'});
                } else if (materialOptionCode === "left_piping") {
                    materialOptionObject = _.find(uniformObject, {code: 'left_under_arm_piping'});
                } else if (materialOptionCode === "right_piping") {
                    materialOptionObject = _.find(uniformObject, {code: 'right_under_arm_piping'});
                }
        }

        return materialOptionObject;
    }

    ub.dataPatches.patchSavedDesign71059MaterialSettings = function(name, object) {
        var materialSettings = object;

        if (typeof ub.config.savedDesignInfo !== "undefined" 
            && ub.config.savedDesignInfo.savedDesignID === "71059") {
                if (name === "left_piping") {
                    materialSettings = ub.funcs.getSettingsByMaterialOptionCode('left_under_arm_piping');
                } else if (name === "left_side_insert") {
                    materialSettings = ub.funcs.getSettingsByMaterialOptionCode('left_under_arm_insert');
                }
        }

        return materialSettings;
    }

    ub.dataPatches.patchForHidePerspectiveCompressionSleeves = function() {
        let items = [
            {
                blockPattern: ['VB Compression Arm Sleeves', 'Compression Arm Sleeves'],
                neckOption: ['Three Quarter Sleeve - Heathered', 'Long Sleeve - Heathered', 'Short Sleeve - Heathered', 'Compression Arm Sleeves']
            },
        ];

        _.find(items, item => {
            if (_.contains(item.blockPattern, ub.config.blockPattern) && _.contains(item.neckOption, ub.config.option)) {
                $('span.perspective[data-id="front"]').hide();
                $('span.perspective[data-id="back"]').hide();
                $('span.part[data-id="Inside Hem"]').hide();
                $('span.part[data-id="Sleeve Panel"]').hide();
                $('span.perspective[data-id="left"]').addClass('active');
            }
        });
    }

    ub.dataPatches.patchForTripleCrownTees = function() {

        let items = [
            {
                blockPattern: ['Triple Crown Tee'],
                neckOption: ['Three Quarter Sleeve - Heathered', 'Long Sleeve - Heathered', 'Short Sleeve - Heathered', 'Compression Arm Sleeves']
            }
        ]

        _.find(items, item => {
            if (_.contains(item.blockPattern, ub.config.blockPattern) && _.contains(item.neckOption, ub.config.option)) {
                $('span.perspective[data-id="front"]').addClass('active').show();
                $('span.perspective[data-id="back"]').hide();
                $('span.part[data-id="Inside Hem"]').show();
                $('span.part[data-id="Sleeve Panel"]').hide();
            }
        });
    }

    ub.dataPatches.initializeTeamColorsForStirrUpSocks = function () {

        let sports  = ['Socks (Apparel)']
        let uniform_type  = ['knitted']
        
        if (_.contains(sports, ub.config.sport) && _.contains (uniform_type, ub.config.uniform_application_type)) {
            ub.current_material.settings.threadColors = true;
            ub.funcs.getThreadColors();
            ub.funcs.getThreadColorsV2();
        }
    }

    ub.dataPatches.savedDesignID254037 = function() {
        if (typeof ub.config.savedDesignInfo === "object" && +ub.config.savedDesignInfo.savedDesignID === 254037) {
            let app71 = ub.current_material.settings.applications[71];
            let app73 = ub.current_material.settings.applications[73];
            let newColorArray = ["T", "B", "W"];

            if (typeof app71 !== "undefined") {
                app71.color_array = ub.colorUtilities.colorCodesToColorObjArray(newColorArray);
                app71.colorArrayText = newColorArray;
            }

            if (typeof app73 !== "undefined") {
                app73.color_array = ub.colorUtilities.colorCodesToColorObjArray(newColorArray);
                app73.colorArrayText = newColorArray;
            }
        }
    }

    ub.dataPatches.run = function () {
        ub.dataPatches.deleteSaveDesignApplication("166172", 74);
        ub.dataPatches.deleteSaveDesignApplication("168104", 75);
        ub.dataPatches.deleteSaveDesignApplication("172725", 74);
        ub.dataPatches.deleteSaveDesignApplication("172910", 79);
        ub.dataPatches.deleteSaveDesignApplication("172910", 80);
        ub.dataPatches.deleteSaveDesignApplication("177573", 79);
        ub.dataPatches.deleteSaveDesignApplication("178845", 75);
        ub.dataPatches.deleteSaveDesignApplication("178842", 76);
        ub.dataPatches.deleteSaveDesignApplication("182258", 78);
        ub.dataPatches.deleteSaveDesignApplication("185031", 78);
        ub.dataPatches.patch4874to5728();
        ub.dataPatches.patchForPerspectiveIssues();
        ub.dataPatches.patchForMaterialOptionPanel();
        ub.dataPatches.patchSavedDesign71059();
        ub.dataPatches.patchForHidePerspectiveCompressionSleeves();
        ub.dataPatches.patchForTripleCrownTees();
        ub.dataPatches.savedDesignID254037();
        ub.dataPatches.initializeTeamColorsForStirrUpSocks();
    };

    ub.dataPatches.runAfterAssetsLoaded = function() {
        ub.dataPatches.avoidHiddenBody();
    };

    ub.dataPatches.orders = function () {
        ub.dataPatches.patch77d6cf0188b0();
    };

});
